import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { PropertyTab, AlloggiatiTab, SpotTab, TablesTab, PrivacyTab } from "@/pages/settings/AdminTabs";
import { RoomsTab, ClosuresTab, UsersTab, SecurityTab } from "@/pages/settings/OtherTabs";
import { TemplatesTab } from "@/pages/settings/TemplatesTab";

export default function Settings() {
  const { user } = useAuth();
  const admin = user?.role === "admin";
  const [prop, setProp] = useState(null);
  const load = () => api.get("/settings/property").then(({ data }) => setProp(data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => {
    load();
  }, []);
  const [params] = useSearchParams();
  const tabs = admin
    ? [["struttura", "Struttura"], ["camere", "Camere"], ["messaggi", "Messaggi"], ["chiusure", "Chiusure"], ["alloggiati", "Alloggiati Web"], ["spot", "DMS / SPOT"], ["tabelle", "Tabelle codici"], ["privacy", "Privacy"], ["utenti", "Utenti"], ["sicurezza", "Sicurezza"]]
    : [["camere", "Camere"], ["messaggi", "Messaggi"], ["chiusure", "Chiusure"], ["sicurezza", "Sicurezza"]];
  return (
    <div className="space-y-6" data-testid="settings-page">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight">Impostazioni</h1>
      {prop && (
        <Tabs defaultValue={tabs.some(([v]) => v === params.get("tab")) ? params.get("tab") : tabs[0][0]}>
          <TabsList className="flex-wrap h-auto justify-start">{tabs.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`settings-tab-${v}`}>{l}</TabsTrigger>)}</TabsList>
          {admin && <TabsContent value="struttura"><PropertyTab prop={prop} onSaved={load} /></TabsContent>}
          <TabsContent value="camere"><RoomsTab admin={admin} /></TabsContent>
          <TabsContent value="messaggi"><TemplatesTab /></TabsContent>
          <TabsContent value="chiusure"><ClosuresTab admin={admin} /></TabsContent>
          {admin && <TabsContent value="alloggiati"><AlloggiatiTab prop={prop} onSaved={load} /></TabsContent>}
          {admin && <TabsContent value="spot"><SpotTab prop={prop} onSaved={load} /></TabsContent>}
          {admin && <TabsContent value="tabelle"><TablesTab prop={prop} onSaved={load} /></TabsContent>}
          {admin && <TabsContent value="privacy"><PrivacyTab prop={prop} onSaved={load} /></TabsContent>}
          {admin && <TabsContent value="utenti"><UsersTab /></TabsContent>}
          <TabsContent value="sicurezza"><SecurityTab /></TabsContent>
        </Tabs>
      )}
    </div>
  );
}
